import axios from "axios";
import { API_HOST } from "@/core/variables";


class AnalyticsRepository {
    getMessagingUserCount = async (scenarioId: string, startDate: string, endDate: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/analytics/messaging-user/count`, {
                params: { startDate, endDate }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    getUserMessageCount = async (scenarioId: string, startDate: string, endDate: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/analytics/user-message/count`, {
                params: { startDate, endDate }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    getFallbackMessageCount = async (scenarioId: string, startDate: string, endDate: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/analytics/fallback/count`, {
                params: { startDate, endDate }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    getEffectiveConversationCount = async (scenarioId: string, startDate: string, endDate: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/analytics/conversation/effective-count`, {
                params: { startDate, endDate }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    getDailyUsageCount = async (scenarioId: string, startDate: string, endDate: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/analytics/usage/day/v2`, {
                params: { startDate, endDate }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    getWeekHourlyMessageCount = async (scenarioId: string, startDate: string, endDate: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/analytics/user-message/week-hourly`, {
                params: { startDate, endDate }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    getIntentRanking = async (scenarioId: string, startDate: string, endDate: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/analytics/intent-rankings`, {
                params: { startDate, endDate }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    getFeedback = async (scenarioId: string, startDate: string, endDate: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/analytics/feedback`, {
                params: { startDate, endDate }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };
}

const analyticsRepository = new AnalyticsRepository();

export default analyticsRepository;
